<template>
  <div
    v-if="!whatsAppMessagesPerAgencyCustomer && loading"
    class="dialog-loading-container"
  >
    <v-progress-circular indeterminate color="primary"></v-progress-circular>
  </div>
  <v-card
    v-if="whatsAppMessagesPerAgencyCustomer"
    flat
    class="sub-site-wrapper"
  >
    <div class="table-statistics-wrapper">
      <v-row>
        <v-col cols="12">
          <whats-app-messages-per-agency-customer
            v-if="whatsAppMessagesPerAgencyCustomer"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="statistics-text-box elevation-3">
            <h5>Informationen zu den Statistiken:</h5>
            <p>
              Es fließen nur Agenturen in die Statistik ein, die eine Stripe
              Subscription ID besitzen und mindestens einen Slot haben.
            </p>
            <p>
              Die Statistiken wurden am <b>{{ statisticsAge }}</b> erstellt.
            </p>
          </div>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>
<script>
import WhatsAppMessagesPerAgencyCustomer from "../charts/WhatsAppMessagesPerAgencyCustomer.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    WhatsAppMessagesPerAgencyCustomer,
  },
  created() {
    this.loadStatistics();
  },
  computed: {
    ...mapState("statistics", [
      "whatsAppMessagesPerAgencyCustomer",
      "loading",
      "statisticsAge",
    ]),
  },
  methods: {
    ...mapActions("statistics", ["fetchMostRecentStatistic"]),
    async loadStatistics() {
      await this.fetchMostRecentStatistic();
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

.table-statistics-wrapper {
  padding: 24px;
}

.statistics-text-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  font-weight: 500;
  border: 1px solid rgb(196, 196, 196);
  border-radius: 12px;
  padding: 12px;
  margin-top: 24px;
}
</style>












